import { useCallback, useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { AlertTypes, type AlertTypesType } from '@/api/types/Alert'

interface ReportFormType {
  type: AlertTypesType[];
  source: string;
  screenshot?: File[];
  notes?: string;
}

const useReportFraudForm = () => {

  const defaultValues = useCallback((): ReportFormType => ({
    type: [],
    source: '',
    screenshot: [],
    notes: '',
  }), [])

  const validationSchema = useMemo(() => (
    z.object({
      type: z.array(z.enum(AlertTypes)).refine(val => val.length > 0, {
        message: 'At least one type is necessary',
      }),
      source: z.url({ message: 'Source URL is required' }),
      screenshot: z.array(z.instanceof(File)).optional(),
      notes: z.string().max(500, 'Character limit exceeded.').optional(),
    })
  ), [])

  const form = useForm<ReportFormType>({
    defaultValues: defaultValues(),
    resolver: zodResolver(validationSchema),
  })

  const resetForm = useCallback(() => {
    form.reset(defaultValues())
  }, [form, defaultValues])

  return {
    form,
    resetForm,
  }
}

export default useReportFraudForm
